import { AbgSxProps } from '@abg/typings';

export const typographyEmptyState: AbgSxProps = (theme) => ({
  color: theme.palette.grey[600],
  margin: 0,
  fontSize: '12px',
  lineHeight: '15px',
});
